// Handle spec: lowercase letters, numbers, and dashes [a-z0-9-], 3-30 characters
const HANDLE_AT_END_REGEX = /^(.+)\/@([a-z0-9-]{3,30})\/?$/i;
const HANDLE_AT_START_REGEX = /^\/@([a-z0-9-]{3,30})(\/.*)?$/i;

export interface AffiliateHandleMatch {
  handle: string;
  rawHandle: string;
  basePath?: string;
  remainingPath?: string;
  position: 'start' | 'end';
}

/**
 * Parses a path to check if it contains an affiliate handle
 * Handles can appear at the start (/@handle/path) or end (/path/@handle)
 *
 * @param path - The URL path to parse
 * @returns Match information if a handle is found, null otherwise
 */
export function parseAffiliateHandle(path: string): AffiliateHandleMatch | null {
  // Check handle at END first (e.g., /search/@handle)
  const handleAtEndMatch = path.match(HANDLE_AT_END_REGEX);
  if (handleAtEndMatch) {
    return {
      rawHandle: handleAtEndMatch[2],
      handle: handleAtEndMatch[2].toLowerCase(),
      basePath: handleAtEndMatch[1],
      position: 'end',
    };
  }

  // Check handle at START (e.g., /@handle/search)
  const handleAtStartMatch = path.match(HANDLE_AT_START_REGEX);
  if (handleAtStartMatch) {
    return {
      rawHandle: handleAtStartMatch[1],
      handle: handleAtStartMatch[1].toLowerCase(),
      remainingPath: handleAtStartMatch[2] || '/',
      position: 'start',
    };
  }

  return null;
}
